import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { event } from '@uhg-abyss/web/tools/event';
import { styled } from '@uhg-abyss/web/tools/styled';
import { storage } from '@uhg-abyss/web/tools/storage';
import { AppContext } from '@src/AppContext';
import { GettingStarted } from './GettingStarted';
import { APIsCategory } from './APIsCategory/APIsCategory';

const WelcomeHeading = styled('h1', {
  color: 'rgb(0, 38, 119)',
  fontSize: '36px ! important',
  fontWeight: 600,
  lineHeight: '40px',
  marginTop: '64px',
  marginBottom: '16px',
});

const TopInstruction = styled('p', {
  color: 'rgb(51, 51, 51)',
  fontSize: '15px',
  fontWeight: 400,
  letterSpacing: '0px',
  lineHeight: '24px',
  width: '100%',
  // '@screen >= $md': {
  //   width: '624px',
  // },
});

const Wrapper = styled('div', {
  paddingLeft: '0px',

  '@screen >= $xs': {
    paddingLeft: '16px',
    paddingRight: '16px',
  },

  '@screen >= $xl': {
    paddingLeft: 0,
    paddingRight: 0,
  },
});

export const NewLanding = () => {
  const contextValue = React.useContext(AppContext);
  const { filters = [], updateFilters } = contextValue || {};
  const userInfo = useSelector((state) => {
    return state.GET_USER_INFO.data;
  });

  const dsUserInfo = useSelector((state) => {
    return state.GET_DS_USER_INFO.data;
  });

  useEffect(() => {
    const signInClicked = storage?.local?.get('IS_SIGN_IN_CLICKED');
    if (!signInClicked) {
      event('LANDING_PAGE_LOAD', { dsUserInfo, userInfo });
    }
    updateFilters(
      [...filters].map((filter) => {
        return { ...filter, checked: false };
      })
    );
    if (storage.local.get('IS_SIGNED_OUT')) {
      storage.local.remove('IS_SIGNED_OUT');
    }
  }, []);

  return (
    <Wrapper>
      <WelcomeHeading>
        Powering the future of health care data integration
      </WelcomeHeading>
      <TopInstruction>
        Easily manage UnitedHealthcare APIs to quickly and securely enable
        seamless connectivity—your practice will spend less time on
        administrative tasks.
      </TopInstruction>
      <GettingStarted />
      <APIsCategory />
    </Wrapper>
  );
};
